export const STATUS_KEY = {
  request: 'request',
  confirm: 'confirm',
  reject: 'reject',
};

export default {
  STATUS_KEY,
};
